import { windowObject } from '../windowObject'
import { appSettings } from './appSettings'

export const CONSENTED = 'consented'

export enum SelectedItem {
  StickyNotes,
  Settings,
  Feedback,
}

export enum ScreenSize {
  Phone = 'Phone',
  TabletPortrait = 'TabletPortrait',
  TabletLandscape = 'TabletLandscape',
  Desktop = 'Desktop',
  DesktopBig = 'DesktopBig',
}

export type IDetailViewState = {
  readonly isDetailViewVisible: boolean
  readonly isSmallScreen: boolean
}

export type IUiState = {
  readonly screenSize: ScreenSize,
  readonly detailView: IDetailViewState,
  readonly isExportDialogOpen: boolean,
  readonly showConsentBanner: boolean
}

export type IState = {
  readonly ui: IUiState
}

export namespace InitialState {
  // tslint:disable-next-line:max-line-length
  export const screenSize = (): ScreenSize =>  windowObject.getMatchedMedia()

  export const detailView = (): IDetailViewState => ({
    isDetailViewVisible: false,
    isSmallScreen: false,
  })

  export const showConsentBanner = (): boolean => {
    // If the consent dialog is off, don't show it regardless of local storage
    if (!appSettings.shouldShowConsentDialog) {
      return false
    }

    if (!localStorage) {
      return true
    }
    try {
      const consented = localStorage.getItem(CONSENTED)
      return !consented
    } catch {
      return true
    }
  }

  export const ui = (): IUiState => {
    return {
      screenSize: screenSize(),
      detailView: detailView(),
      isExportDialogOpen: false,
      showConsentBanner: showConsentBanner(),
    }
  }

  export const app = (): IState => ({
    ui: ui(),
  })
}
